import React from 'react';

const Footer = () => {
  return (
    <footer className="relative w-full text-white">
      <div
        className="relative bg-cover bg-center"
        style={{
          backgroundImage: "url('/images/background-4.jpg')",
        }}
      >
        <div className="absolute inset-0 bg-black/80"></div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-6 pt-20 pb-32 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
          <div>
            <h3 className="text-2xl font-bold mb-4 text-white">
              About BEDC Electricity
            </h3>
            <p className="text-sm leading-relaxed text-gray-300">
              BEDC Electricity Plc. (BEDC) is one of the successor distribution
              companies (Discos) created following the unbundling and
              privatization of the state-owned Power Utility, Power Holding
              Company of Nigeria Plc.
            </p>
          </div>
          
          <div>
            <h3 className="text-2xl font-bold mb-4 text-white">Quick Links</h3>
            <ul className="space-y-3 text-sm text-gray-300">
              <li>
                <a href="/about-us" className="hover:text-[#facc15] transition-colors duration-300">About Us</a>
              </li>
              <li>
                <a href="https://imaap.beninelectric.com" className="hover:text-[#facc15] transition-colors duration-300">Order a Meter</a>
              </li>
              <li>
                <a href="/careers" className="hover:text-[#facc15] transition-colors duration-300">Careers</a>
              </li>
              {/* <li>
                <a href="/privacy-policy" className="hover:text-[#facc15] transition-colors duration-300">Privacy Policy</a>
              </li> */}
              <li>
                <a href="/contact" className="hover:text-[#facc15] transition-colors duration-300">Contact Us</a>
              </li>
            </ul>
          </div>
          
          <div>
             <ul className="space-y-3 text-sm text-gray-300">
              <li>
                <a href="/customer-feeder-info" className="hover:text-[#facc15] transition-colors duration-300">Feeder Information</a>
              </li>
              <li>
                <a href="https://crm.beninelectric.com/complaints" target='blank' className="hover:text-[#facc15] transition-colors duration-300">Report outages and issues</a>
              </li>
              <li>
                <a href="https://imaap.beninelectric.com" target='blank' className="hover:text-[#facc15] transition-colors duration-300">Order a Meter</a>
              </li>
              <li>
                <a href="https://newsetup.beninelectric.com" target='blank' className="hover:text-[#facc15] transition-colors duration-300">New Account Creation</a>
              </li>
            </ul>
          </div>
        </div>

        {/* CURVED SECTION WITH YELLOW TOUCH */}
        <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-none z-20">
          <svg
            className="relative block w-full h-24"
            viewBox="0 0 1440 100"
            preserveAspectRatio="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            {/* The Yellow Layer (The "Touch" of Yellow) */}
            <path
              d="M0 0C300 70 1140 70 1440 0V100H0V0Z"
              fill="#facc15" 
            />
            {/* The Green Layer (Slightly lower to reveal the yellow above it) */}
            <path
              d="M0 10C300 80 1140 80 1440 10V100H0V10Z"
              className="fill-green-700"
            />
          </svg>
        </div>
      </div>

      {/* FINAL BOTTOM BAR */}
      <div className="bg-green-700 text-center py-8 text-sm font-medium border-t border-green-600/30">
        <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p>© 2026 BEDC Electricity Plc. All rights reserved.</p>
          <div className="flex gap-6 opacity-70">
            <p>...Committed to serving you better...</p>
          </div>
        </div>
      </div>
 
    </footer>
  );
};

export default Footer;